export const environment = {
  production: true,
  api: 'https://api.bydenergia.com',
  weatherKey: '08c7ea34e65ec575ceebcd3d9a5a0f05',
  staging: false,
}
